import { Action } from '../types';

export interface State {
  redirectTo: string | null;
  hasPasskeys: boolean;
}

export const defaultState: State = {
  redirectTo: null,
  hasPasskeys: false,
};

export default (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'MFA_PROMOTE_REDIRECT':
      return {
        ...state,
        redirectTo: action.redirectTo,
      };
    default:
      return state;
  }
};
